import React from 'react'
import './BackgroundGradient.css'

/**
 * BackgroundGradient — Aceternity-style blurred radial gradient border.
 * Two layered spans: one blurred (soft bloom) + one sharp (crisp border line),
 * both revealed through the 3px wrapper padding around the inner content.
 */
export function BackgroundGradient({ children, className = '', containerClassName = '' }) {
  return (
    <div className={`bg-gradient-wrap ${containerClassName}`.trim()}>
      <span className="bg-gradient-blur"  aria-hidden="true" />
      <span className="bg-gradient-sharp" aria-hidden="true" />
      <div className={`bg-gradient-content ${className}`.trim()}>
        {children}
      </div>
    </div>
  )
}
